import {
  type Axis,
  type FanOutVariable,
  type MediaBrowserPanelConfig,
} from '../../../../PanelMediaBrowser/common';

type GridSettings = NonNullable<MediaBrowserPanelConfig['gridSettings']>;
type AxisKey = keyof GridSettings;

function getOtherAxisKey(axisKey: AxisKey): AxisKey {
  return axisKey === 'xAxis' ? 'yAxis' : 'xAxis';
}

export function updateAxisConfig(
  option: Axis,
  gridSettings: GridSettings,
  updateConfig: (config: Partial<MediaBrowserPanelConfig>) => void,
  axisKey: AxisKey
) {
  const otherAxisKey = getOtherAxisKey(axisKey);
  // When the same axis is picked for both cause a swap
  if (option === gridSettings[otherAxisKey]) {
    updateConfig({
      gridSettings: {
        ...gridSettings,
        [otherAxisKey]: gridSettings[axisKey],
        [axisKey]: option,
      },
    });
  } else {
    updateConfig({
      gridSettings: {
        ...gridSettings,
        [axisKey]: option,
      },
    });
  }
}

/**
 * Updates the fanOutVariable in compareSettings
 * When value is undefined, the field is omitted (removed) from compareSettings
 */
export function setFanOutVariable(
  compareSettings: MediaBrowserPanelConfig['compareSettings'],
  updateConfig: (config: Partial<MediaBrowserPanelConfig>) => void,
  value: FanOutVariable | undefined
) {
  const {fanOutVariable, ...restCompareSettings} = compareSettings || {};
  updateConfig({
    compareSettings: {
      ...restCompareSettings,
      ...(value !== undefined ? {fanOutVariable: value} : {}),
    },
    page: {start: 0},
  });
}
